import { absoluteUrl } from './siteUrls.js';

const DEFAULT_OG_IMAGE = absoluteUrl('/og-image.jpg');

/** Update document title and meta tags for SEO / social sharing. */
export function applyPageMeta({
  title,
  description,
  lang,
  ogLocale,
  pathname,
  ogType = 'website',
  keywords,
  ogImage,
}) {
  if (typeof document === 'undefined') return;

  document.title = title;
  document.documentElement.lang = lang;

  setMeta('name', 'description', description);
  setMeta('property', 'og:title', title);
  setMeta('property', 'og:description', description);
  setMeta('property', 'og:locale', ogLocale);
  setMeta('property', 'og:type', ogType);
  setMeta('property', 'og:image', ogImage || DEFAULT_OG_IMAGE);

  if (keywords != null) {
    const kw = String(keywords).trim();
    if (kw) setMeta('name', 'keywords', kw);
    else removeMeta('name', 'keywords');
  }

  if (pathname != null) {
    const url = absoluteUrl(pathname);
    setMeta('property', 'og:url', url);
    setCanonical(url);
  }
}

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function removeMeta(attr, key) {
  document.head.querySelector(`meta[${attr}="${key}"]`)?.remove();
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}
